/**
 * @generated SignedSource<<661542cc106077659aaf264b07310186>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutBuyerChargeCurrency_viewer$data = {
  readonly chargeCurrencies: ReadonlyArray<Currency | null> | null;
  readonly " $fragmentType": "CheckoutBuyerChargeCurrency_viewer";
};
export type CheckoutBuyerChargeCurrency_viewer$key = {
  readonly " $data"?: CheckoutBuyerChargeCurrency_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBuyerChargeCurrency_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBuyerChargeCurrency_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chargeCurrencies",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8cdde267df452e7d4740e0638ba44e32";

export default node;
